import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-quick-link',
  templateUrl: './quick-link.component.html',
  styleUrls: ['./quick-link.component.scss'],
})
export class QuickLinkComponent implements OnInit {
  @Input() link: any;
  engagementId:any = "";
  constructor(private router:Router, private route:ActivatedRoute) {}

  ngOnInit(): void {
    this.engagementId = this.route.snapshot.paramMap.get('id');
  }

  goto(linkName:any){
    if(this.engagementId != "")
    {
      if(linkName == "Asset Library"){
        this.router.navigate([`/asset-library`, this.engagementId]);
      }
      if(linkName == "Contractual Documents"){
        this.router.navigate([`/contractual-docs`, this.engagementId]);
      }
    }
  
  }
}
